 import Cookies from 'js-cookie'

 const TokenKey = 'Admin-Token'
 const EmailKey = 'Admin-Email'

 export function getToken() {
   return Cookies.get(TokenKey)
 }

 export function setToken(token) {
   return Cookies.set(TokenKey, token)
 }

 export function removeToken() {
   return Cookies.remove(TokenKey)
 }


export function getEmail() {
    return Cookies.get(EmailKey)
}

export function setEmail(token) {
    return Cookies.set(EmailKey, token)
}

export function removeEmail() {
    return Cookies.remove(EmailKey)
}
